// Color-preference storage-key helpers extracted verbatim from
// InteractiveGraph.js (IG-split Slice 4, pure-function seam). Behavior is
// byte-identical to the original module-level definitions; only the
// definitions that InteractiveGraph.js consumes are exported. The scope
// aliases / prefix / stage-key helper stay module-internal, exactly as they
// were when co-located inside the component file.

const COLOR_PREFERENCE_STORAGE_PREFIX = 'graphTutorColorPrefs';

const VALID_COLOR_SCOPE_ALIASES = {
  user: 'user',
  student: 'user',
  account: 'user',
  profile: 'user',
  graph: 'graph',
  chart: 'graph',
  session: 'graph',
  stage: 'stage',
  step: 'stage'
};

export const createDefaultColorOverrides = () => ({
  label: null,
  legendText: null,
  legendBackground: null,
  explanation: null,
  elements: {}
});

export const createDefaultHighlightOptions = () => ({
  labels: false,
  legend: false,
  explanation: false
});

export const normalizeColorPreferenceScope = (inputScope) => {
  if (!inputScope) return 'graph';
  const normalized = String(inputScope).toLowerCase().trim();
  return VALID_COLOR_SCOPE_ALIASES[normalized] || 'graph';
};

const resolveStageStorageKey = (stageData, stageIndex) => {
  if (stageData?.stage_id) return stageData.stage_id;
  if (stageData?.id) return stageData.id;
  if (typeof stageIndex === 'number' && stageIndex >= 0) return `stage-${stageIndex}`;
  return 'stage-0';
};

export const buildColorPreferenceStorageKey = (
  graphData,
  studentProfile,
  scope = 'graph',
  currentStageData = null,
  currentStageNum = 0
) => {
  const normalizedScope = normalizeColorPreferenceScope(scope);
  const studentKey = studentProfile?.student_id || 'student';
  if (normalizedScope === 'user') {
    return `${COLOR_PREFERENCE_STORAGE_PREFIX}:${studentKey}`;
  }
  const graphKey =
    graphData?.graph_id ||
    graphData?.id ||
    graphData?.graph_key ||
    graphData?.title ||
    'graph';
  if (normalizedScope === 'stage') {
    const stageKey = resolveStageStorageKey(currentStageData, currentStageNum);
    return `${COLOR_PREFERENCE_STORAGE_PREFIX}:${studentKey}:${graphKey}:${stageKey}`;
  }
  return `${COLOR_PREFERENCE_STORAGE_PREFIX}:${studentKey}:${graphKey}`;
};
